import { render } from "./logout.vue?vue&type=template&id=7b6148de&scoped=true"
import script from "./logout.vue?vue&type=script&setup=true&lang=js"
export * from "./logout.vue?vue&type=script&setup=true&lang=js"

import "./logout.vue?vue&type=style&index=0&id=7b6148de&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6148de"],['__file',"pages/EndataAuth/Account/App/components/profile/logout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b6148de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b6148de', __exports__)) {
    api.reload('7b6148de', __exports__)
  }
  
  module.hot.accept("./logout.vue?vue&type=template&id=7b6148de&scoped=true", () => {
    api.rerender('7b6148de', render)
  })

}


export default __exports__